import React from 'react';

import SidebarComponent from '../../components/sidebar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from '../login/login';
import Items from '../items/items';
import Users from '../users/user';
import Cranes from '../cranes/cranes';
import PenalitiesList from '../penalities/list';
import Rules from '../rules/rules';
import Forces from '../forces/forces';
import Officials from '../officials/officials';
import DetailOfficer from '../officials/detail';
import DetailPenalitie from '../penalities/detail';
import NewPenalitie from '../penalities/new';
import Concepts from '../concepts/concepts';
import Payments from '../payments/payments';
import UsersPenalities from '../penalities/users';
import FactorComponent from '../factor/factor';
import AuditComponent from '../audit/audit';
import Metrics from '../metrics';
import NullationComponent from '../nullables';
import { TreasuryComponent } from '../treasury/main';
import RevocationsComponent from '../revocations/index';
import PaymentValidation from '../paymentValidation';
import OfficialFines from '../officialFines';
import { isLoged } from '../../Shared/functions';
import { BASE_URL } from '../../Shared/Constants';

const MainPage = () => {
    if(isLoged()) {
        return renderService()
    }else{
        return (
            <div>
                <Login/>
            </div>
        )
    }
};

const renderService = () => {
        return (
        <div>
            <BrowserRouter>
                <div>
                    <SidebarComponent />
                    <div className="lg:pl-72">
                        <main className="py-10">
                            <div className="px-4 sm:px-6 lg:px-8">
                                <Routes>
                                    <Route path={BASE_URL+"/"} element={<Items />} />
                                    <Route path={BASE_URL+"/users"} element={<Users />} />
                                    <Route path={BASE_URL+"/cranes"} element={<Cranes />} />
                                    <Route path={BASE_URL+"/penalities"} element={<PenalitiesList />} />
                                    <Route path={BASE_URL+"/users/penalities/:id"} element={<DetailPenalitie />} />
                                    <Route path={BASE_URL+"/penalities/new"} element={<NewPenalitie/>}/>
                                    <Route path={BASE_URL+"/users/penalities"} element={<UsersPenalities/>}/>
                                    <Route path={BASE_URL+"/rules"} element={<Rules />} />
                                    <Route path={BASE_URL+"/forces"} element={<Forces />} />
                                    <Route path={BASE_URL+"/officials"} element={<Officials />} />
                                    <Route path={BASE_URL+"/officials/:id"} element={<DetailOfficer />} />
                                    <Route path={BASE_URL+"/concepts"} element={<Concepts />} />
                                    <Route path={BASE_URL+"/payments"} element={<Payments />} />
                                    <Route path={BASE_URL+"/factor"} element={<FactorComponent />} />
                                    <Route path={BASE_URL+"/audit"} element={<AuditComponent />} />
                                    <Route path={BASE_URL+'/treasure'} element={<TreasuryComponent/>} />
                                    <Route path={BASE_URL+'/metrics'} element={<Metrics/>} />
                                    <Route path={BASE_URL+'/nullations'} element={<NullationComponent/>} />
                                    <Route path={BASE_URL+'/revocations'} element={<RevocationsComponent/>} />
                                    <Route path={BASE_URL+'/payment-validation'} element={<PaymentValidation/>} />
                                    <Route path={BASE_URL+'/official-fines'} element={<OfficialFines/>} />
                                </Routes>
                            </div>  
                        </main>
                    </div>
                </div>    
             </BrowserRouter>
        </div>
        
    );
}

export default MainPage;
